import { QueryStatus, useQuery } from '@tanstack/react-query';
import { fetchSolar } from './fetchSolar';
import { SolarType } from '../CommonTypes';
import useSite from './useSite';

export default function useSolars(viewid?: string) {
  const [site] = useSite();
  const results = useQuery({
    queryKey: ['company', site.company, 'siteId', site.siteid, 'solarScenes'],
    queryFn: () => fetchSolar(site.company, site.siteid),
  });

  const filteredResult = viewid ? results?.data?.filter(doc => doc.viewid === viewid) : results?.data;
  const defaultIndex = filteredResult?.findIndex(solar => solar.default);

  return [filteredResult?.sort((a, b) => a.order - b.order) ?? [], defaultIndex, results.status] as [
    SolarType[],
    number | undefined,
    QueryStatus,
  ];
}
